var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersInfluencers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33301 4.66683C9.33301 6.50776 7.84061 8.00016 5.99967 8.00016C4.15874 8.00016 2.66634 6.50776 2.66634 4.66683C2.66634 2.8259 4.15874 1.3335 5.99967 1.3335C7.84061 1.3335 9.33301 2.8259 9.33301 4.66683ZM1.33301 13.3335V14.0002C1.33301 14.3683 1.63147 14.6668 1.99967 14.6668H9.99967C10.3679 14.6668 10.6663 14.3683 10.6663 14.0002V13.3335C10.6663 11.8607 9.47247 10.6668 7.99967 10.6668H3.99967C2.52687 10.6668 1.33301 11.8607 1.33301 13.3335ZM9.32927 7.93056C9.54601 7.9749 9.76981 8.00016 9.99967 8.00016C11.8406 8.00016 13.333 6.50776 13.333 4.66683C13.333 2.8259 11.8406 1.3335 9.99967 1.3335C9.76981 1.3335 9.54601 1.35883 9.32927 1.4031C10.155 2.24536 10.6663 3.3971 10.6663 4.66683C10.6663 5.93656 10.155 7.08823 9.32927 7.93056ZM11.9997 10.6668H10.9727C11.6089 11.3754 11.9997 12.3085 11.9997 13.3335V14.6668H13.9997C14.3679 14.6668 14.6663 14.3683 14.6663 14.0002V13.3335C14.6663 11.8607 13.4725 10.6668 11.9997 10.6668Z",
    fill: "#16162C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersInfluencers);
export default __webpack_public_path__ + "static/media/usersInfluencers.4310b30ca1fee3ea0add1f350390be79.svg";
export { ForwardRef as ReactComponent };